import CacheHelper from "@/helper/CacheHelper.js"
import liff from '@line/liff' // https://www.npmjs.com/package/@line/liff

/**
 * @function init
 * @function getAccessToken
 * @function getIdToken
 * @function isLogin
 * @function login
 * @function logout
 * @function isTokenExpire
 * @function closeWindow
 * @function openExternalWindow
 * @function getLanguage
 * @function getLiffId
 * @function getProfile
 * @function shareTextToFriends
 */
export default class LineFunction {
    constructor() {
        this.lineLiff = liff
    }

    //#region initial
    /**
     * @param {string} liffId Line liff id
     */
    init(liffId) {
        return this.lineLiff.init({
            liffId: liffId,
            withLoginOnExternalBrowser: true,
        })

    }
    //#endregion initial

    //#region login
    getAccessToken() {
        try {
            return this.lineLiff.getAccessToken();
        } catch (e) {
            return null;
        }
    }

    getIdToken() {
        try {
            return this.lineLiff.getIDToken();
        } catch (e) {
            return null;
        }
    }

    isLogin() {
        try {
            return this.lineLiff.isLoggedIn();
        } catch (e) {
            return false;
        }
    }

    /**
     *! This function will redirect to page Line auth.
     * @param {string} callbackUrl
     */
    login(callbackUrl) {
        try {
            this.lineLiff.login({ redirectUri: callbackUrl })
        } catch (e) {
            console.log(e);
        }
    }

    logout() {
        try {
            this.lineLiff.logout();
        } catch (e) {
            console.log(e);
        }
    }

    isTokenExpire() {
        let obj = this.lineLiff.getDecodedIDToken();
        if (!obj || !obj.exp || isNaN(obj.exp)) {
            return true;
        }
        let expireDate = new Date(obj.exp * 1000);
        expireDate.setMinutes(expireDate.getMinutes() - 30);

        let current = new Date();
        return current.getTime() >= expireDate.getTime();
    }
    getDecodeIdToken() {
        try {
            return this.lineLiff.getDecodedIDToken();
        } catch (e) {
            console.log(e);
        }
    }
    //#endregion login

    //#region browser window control
    closeWindow() {
        try {
            this.lineLiff.closeWindow();
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * @param {string} url
     */
    openExternalWindow(url) {
        try {
            this.lineLiff.openWindow({
                url: url,
                external: true
            })
        } catch (e) {
            console.log(e);
        }
    }
    //#endregion browser window control

    //#region info
    getLanguage() {
        try {
            return this.lineLiff.getLanguage();
        } catch (e) {
            return null;
        }
    }
    setLiffId(liffId) {
        let cache = new CacheHelper('cookie');
        return cache.setCacheRaw('LineLiffIdLanding', liffId);
    }
    getLiffId() {
        let cache = new CacheHelper('cookie');
        return cache.getCacheRaw('LineLiffIdLanding');
    }
    getProfile() {
        try {
            return this.lineLiff.getProfile();
        } catch (e) {
            console.log(e);
        }
    }
    //#endregion info

    //#region share
    shareTextToFriends(msg) {
        return new Promise((resolve, reject) => {
            if (this.lineLiff.isApiAvailable('shareTargetPicker')) {
                this.lineLiff.shareTargetPicker([
                    {
                        'type': 'text',
                        'text': msg
                    }
                ]).then((res) => {
                    if (res) {
                        // alert(`[${res.status}] Message sent!`)
                        resolve({
                            status: true,
                            msg: res,
                        });
                    } else {
                        const [majorVer, minorVer] = (this.lineLiff.getLineVersion() || "").split('.');
                        if (parseInt(majorVer) == 10 && parseInt(minorVer) < 11) {
                            // LINE 10.3.0 - 10.10.0
                            // Old LINE will access here regardless of user's action
                            resolve({
                                status: true,
                                msg: res,
                                info: 'TargetPicker was opened at least. Whether succeeded to send message is unclear',
                            });
                            // alert('TargetPicker was opened at least. Whether succeeded to send message is unclear')
                        } else {
                            // LINE 10.11.0 -
                            // sending message canceled
                            reject({
                                status: true,
                                info: 'TargetPicker was closed!',
                            });
                            // alert('TargetPicker was closed!')
                        }
                    }
                }).catch((err) => {
                    reject({
                        status: false,
                        err: err,
                        msg: null,
                    });
                });
            } else {
                reject({
                    status: false,
                    msg: 'line else case',
                })
            }
        });
    }
    //#endregion share
      //#region scan qr
  scanQrCodeV2() {
    return new Promise((resolve, reject) => {
            this.lineLiff.scanCodeV2().then((res) => {
                resolve(res);
            }).catch((e) => {
                reject({
                    status: false,
                    err: e,
                    msg: null,
                })
            });
        });
    }
//#endregion scan qr
}
